import { css } from '@Root/lib/lit-3form-block';

// Important Note: Dipper and Mabel are twins. They are quite similar but have
// subtle differences. That said, keep in mind that a change made to one
// ** might ** also be needed in the other.

export const styles = [
  css`
    .mabel-layout {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--top-padding-height);
      max-width: 100%;
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 2;
      padding-bottom: calc(20rem / var(--default-rem-px-count));
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    .desktop-only {
      display: none;
    }

    .mobile-only {
      display: inherit;
    }

    h1 {
      line-height: unset;
      padding-bottom: calc(20rem / var(--default-rem-px-count));
    }

    h3 {
      font-size: calc(18rem / var(--default-rem-px-count));
      letter-spacing: -0.32px;
      line-height: calc(24rem / var(--default-rem-px-count));
    }

    img {
      max-width: 100%;
    }

    .images {
      display: flex;
      flex-wrap: wrap;
      gap: calc(60rem / var(--default-rem-px-count));
      padding-top: calc(40rem / var(--default-rem-px-count));
    }

    .image-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;

      .image-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        cta-text {
          margin-top: auto;
        }
      }

      .image {
        width: 100%;
        display: flex;
        align-items: center;
        padding-top: calc(20rem / var(--default-rem-px-count));
      }

      .image-description {
        padding: calc(20rem / var(--default-rem-px-count)) 0;
        line-height: 1.45em;
        text-wrap: pretty;
      }
    }

    @media (min-width: 600px) {
      .mabel-layout {
        grid-template-rows:
          var(--top-padding-height)
          minmax(0, auto)
          minmax(0, auto)
          var(--top-padding-height);
        align-items: start;
      }

      .header {
        grid-column: 2 / 5;
        grid-row: 2;
      }

      .description {
        grid-column: 8 / 12;
        grid-row: 2;
      }

      .desktop-only {
        display: inherit;
      }

      .mobile-only {
        display: none;
      }

      h1 {
        padding-bottom: calc(40rem / var(--default-rem-px-count));
      }

      .images {
        grid-column: 2 / 14;
        grid-row: 3;
        gap: calc(2 * var(--between-column-padding))
          var(--between-column-padding);
        display: grid;
        max-width: 100%;
        padding-top: calc(60rem / var(--default-rem-px-count));
      }

      .two-per-row {
        grid-template-columns: repeat(2, [col] var(--column-width));
      }

      .three-per-row {
        grid-template-columns: repeat(3, [col] var(--column-width));
      }

      .image-description {
        max-width: 66.66%;
      }
    }
  `,
];
